import { useLocation } from 'react-router-dom';

export default function useQueryString() {
  const location = useLocation(),
    params = new URLSearchParams(location.search),
    queryString = params.toString();

  return queryString ? `?${queryString}` : '';
}
